<template>
  <section class="inputcomps-container">
    <span class="isRequred" v-if="isRequired">*</span>
    <input
      :class="[{ error: isError }, { focus: isFocus }]"
      placeholder="请输入"
      :value="value"
      autocomplete="on"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="handleInput"
    />
    <div class="errtips" v-if="isError">请输入内容</div>
  </section>
</template>

<script>
/**
 * 单选、多选输入框组件
 */
export default {
  name: 'InputComps',
  props: {
    isRequired: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFocus: false,
      isError: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleFocus() {
      this.isFocus = true;
    },
    handleBlur() {
      this.isFocus = false;
      if (!this.value && this.isRequired) {
        this.isError = true;
      }
    },
    handleInput(e) {
      const value = e.target.value;
      if (value) {
        this.isError = false;
      }
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="less" scoped>
.inputcomps-container {
  margin-top: 8px;
  margin-left: 32px;
  position: relative;
  .isRequred {
    color: #ff3b30;
    font-size: 18px;
    position: absolute;
    left: -20px;
  }
  input {
    width: 100%;
    padding-left: 10px;
    box-sizing: border-box;
    height: 44px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.09);
    &.focus {
      border: 1px solid #ff6600;
    }
    &.error {
      border: 1px solid #ff3b30;
    }
  }
  .errtips {
    font-size: 14px;
    font-weight: 400;
    color: #ff3b30;
    line-height: 25px;
    margin-top: 4px;
  }
}
</style>
